import React, { Component } from 'react'
import Logo from './Logo';
import { GiHamburgerMenu } from "react-icons/gi";
import Nav from "./Nav";

export default class Header extends Component {
	constructor(context) {
		super(context);
		this.state = {
			open: false
		};
	}

	render() {
		return (
			<div id="head">
				<div id="menu" onClick={() => this.setState({ open: !this.state.open })}>
					<GiHamburgerMenu size="2em" />
					{this.state.open && <Nav />}
				</div>
	          	<Logo/>
	        </div>
          )
	}
}